import Grid from '@mui/material/Grid2';
import { InvoiceSenderSettings } from './InvoiceSenderSettings';
import { UyumsoftSettings } from './UyumsoftSettings';

export const InvoiceSettings = () => {
  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12, lg: 6 }}>
        <InvoiceSenderSettings />
      </Grid>
      <Grid size={{ xs: 12, lg: 6 }}>
        <UyumsoftSettings />
      </Grid>
    </Grid>
  );
};
